/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiCoordinate
 */
export interface ApiCoordinate {
    /**
     * X-axis of the position
     * @type {number}
     * @memberof ApiCoordinate
     */
    x: number;
    /**
     * Y-axis of the position
     * @type {number}
     * @memberof ApiCoordinate
     */
    y: number;
    /**
     * 
     * @type {string}
     * @memberof ApiCoordinate
     */
    friendlyName?: string;
}

export function ApiCoordinateFromJSON(json: any): ApiCoordinate {
    return ApiCoordinateFromJSONTyped(json, false);
}

export function ApiCoordinateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCoordinate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'friendlyName': !exists(json, 'friendlyName') ? undefined : json['friendlyName'],
    };
}

export function ApiCoordinateToJSON(value?: ApiCoordinate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'friendlyName': value.friendlyName,
    };
}

